// ProtectedRoute.js
import { Navigate, Outlet } from "react-router-dom";
import { useAPI } from "../../Context/MyContext";

const ProtectedRoute = () => {
    const { user } = useAPI();

    if (!user?.token) {
        return <Navigate to="/" replace />;
    }

    return <Outlet />;
};

export default ProtectedRoute;